import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

// ─────────────────────────────────────────────────────────────────────────────
// CRUD
// ─────────────────────────────────────────────────────────────────────────────

export const createReport = async () => {
  try {
    const res = await axios.post(
      BASE_URL + "reports/create",
      {},
      { headers: authHeader() },
    );
    return res;
  } catch (e) {
    console.error("createReport error:", e);
    return null;
  }
};

export const listReports = async () => {
  try {
    const res = await axios.get(BASE_URL + "reports/list", {
      headers: authHeader(),
    });
    return res;
  } catch (e) {
    console.error("listReports error:", e);
    return null;
  }
};

export const getReport = async (reportId) => {
  try {
    const res = await axios.get(BASE_URL + "reports/get/" + reportId, {
      headers: authHeader(),
    });
    return res;
  } catch (e) {
    console.error("getReport error:", e);
    return null;
  }
};

export const deleteReport = async (reportId) => {
  try {
    const res = await axios.delete(BASE_URL + "reports/delete/" + reportId, {
      headers: authHeader(),
    });
    return res;
  } catch (e) {
    console.error("deleteReport error:", e);
    return null;
  }
};

export const renameReport = async (reportId, title) => {
  try {
    const res = await axios.put(
      BASE_URL + "reports/rename/" + reportId,
      { title },
      { headers: authHeader() },
    );
    return res;
  } catch (e) {
    console.error("renameReport error:", e);
    return null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Undo / Redo
// ─────────────────────────────────────────────────────────────────────────────

export const undoReport = async (reportId) => {
  try {
    const res = await axios.post(
      BASE_URL + "reports/undo",
      { report_id: reportId },
      { headers: authHeader() },
    );
    return res;
  } catch (e) {
    console.error("undoReport error:", e);
    return null;
  }
};

export const redoReport = async (reportId) => {
  try {
    const res = await axios.post(
      BASE_URL + "reports/redo",
      { report_id: reportId },
      { headers: authHeader() },
    );
    return res;
  } catch (e) {
    console.error("redoReport error:", e);
    return null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// Streaming chat — uses raw fetch (axios doesn't support ReadableStream)
// ─────────────────────────────────────────────────────────────────────────────

export const streamReportChat = async ({
  reportId,
  message,
  userDatetime,
  signal,
}) => {
  try {
    const res = await fetch(BASE_URL + "reports/chat", {
      method: "POST",
      headers: {
        ...authHeader(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        report_id: reportId,
        message,
        user_datetime: userDatetime,
      }),
      signal,
    });
    return res;
  } catch (e) {
    if (e.name !== "AbortError") {
      console.error("streamReportChat error:", e);
    }
    return null;
  }
};
